export default class CountDownTimer extends HTMLElement {
  constructor() {
    super();
    this.getOrderByDate();
  }

  getOrderByDate() {
    let currentDate = new Date();
    console.log(currentDate);
  }
}

customElements.define('countdown-timer', CountDownTimer);
